<ix-layout-grid>
  <ix-row>
    <ix-col>
      <ix-content-header
        [hasBackButton]="true"
        (backButtonClick)="onBackButtonClick()"
        headerTitle="
          {{
          'um.edit_user'
            | translate
              : {
                  firstName: userData?.firstName || '',
                  lastName: userData?.lastName || '',
                }
        }}"
      id="editUserHeader"
      >
    </ix-content-header>
  </ix-col>
</ix-row>
@if (loadingWhileFetching) {
  <ix-row>
    <ix-col class="d-flex justify-content-center">
      <ix-spinner size="large" class="mt-5"></ix-spinner>
    </ix-col>
  </ix-row>
}
@if (!loadingWhileFetching && userData) {
  <ix-row>
    <ix-col>
      <ng-container>
        <app-user-form
          (userDataChange)="saveUser($event)"
          [(userData)]="userData"
          [cancelEvent]="cancelEvent"
          [cancelRoute]="targetRoute"
          [loading]="loadingWhileSaving"
          userFormType="admin-save"
        ></app-user-form>
      </ng-container>
    </ix-col>
  </ix-row>
}
</ix-layout-grid>
